<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="svg-icon">
    <path
      d="M19,7.36,16.82,3.64,12.18,6.28V1H7.82V6.28L3.18,3.64,1,7.36,5.65,10,1,12.64l2.18,3.72,4.64-2.64V19h4.36V13.72l4.64,2.64L19,12.64,14.35,10Z"
      fill="currentColor"
    />
  </svg>
</template>
